angular.module('unica_auth.auth_services')

.factory('LogoutService', function ($http, getBaseApiURL, Session) {


	var LogoutService = {};

	LogoutService.logout = function() {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/auth/logout',
			data: { }
		}).then(function(result) {

			if ( result ) {
				Session.destroy();
				return true;
			}

		});
	};

	return LogoutService;
});